<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-2">
              Aqui é possível cadastrar um novo administrador de sistema. Por
              questões de segurança, certifique-se de inserir as informações
              corretas, pois o usuário criado terá acesso a todas funções
              administrativas do sistema.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Novo administrador</h3>
                </div>
                <div class="col-4 text-right">
                  <span class="btn btn-sm btn-primary">Perfil</span>
                </div>
              </div>
            </div>
            <template>
              <form role="form">
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações da conta
                  </h6>
                </div>
                <div class="row ml-2">
                  <div class="col-12">
                    <label class="form-control-label">Email do usuário</label>
                    <base-input
                      placeholder="Email"
                      addon-left-icon="ni ni-email-83"
                      v-model="model.user.email"
                    >
                    </base-input>
                  </div>
                  <div class="col-12">
                    <label class="form-control-label">Senha do usuário</label>
                    <base-input
                      placeholder="Senha"
                      type="password"
                      addon-left-icon="ni ni-lock-circle-open"
                      v-model="model.user.password"
                    >
                    </base-input>
                  </div>
                  <div
                    v-if="model.user.password.length"
                    class="text-muted font-italic text-right col-12"
                  >
                    <small
                      >segurança da senha:
                      <span
                        class="font-weight-700"
                        :class="passwordStatus.class"
                        >{{ passwordStatus.message }}</span
                      ></small
                    >
                  </div>
                </div>
                <div class="row ml-1 mt-3">
                  <h6 class="heading-small text-muted mb-4">
                    Informações básicas
                  </h6>
                </div>
                <div class="row ml-2">
                  <div class="col-lg-6">
                    <base-input
                      label="Nome do administrador"
                      v-model="model.admin.name"
                      placeholder="Nome completo"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Função na Stars"
                      v-model="model.admin.company_position"
                      placeholder="Qual a função do administrador na STARS?"
                    />
                  </div>
                </div>
                <div class="row ml-2" v-if="error">
                  <div class="col-lg-12 text-center">
                    <base-alert type="danger">{{ error }}</base-alert>
                  </div>
                </div>
                <div class="text-right">
                  <base-button
                    type="primary"
                    class="mt-4"
                    :custom="true"
                    @click="handleOpenModalConfirmation"
                    :disabled="!isValidModel"
                    >Criar novo administrador</base-button
                  >
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation">
        <div class="py-3 text-center">
          <i class="fa fa-user-shield fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja criar o administrador
            <span class="text-warning">{{ model.admin.name }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            O administrador terá acesso a todas as funcionalidades
            administrativas e poderá visualizar todos os dados disponíveis na
            plataforma.
          </p>
          <p class="mt-3">
            Por favor, digite
            <span class="text-warning font-weight-bold">{{
              model.user.email
            }}</span>
            para prosseguir
          </p>
          <base-input
            placeholder="Digite aqui"
            input-classes="form-control"
            addon-left-icon="fas fa-trash text-warning"
            v-model="modals.inputConfirmation"
          />
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.modalConfirmation = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleSubmitNewAdmin"
          :disabled="!inputConfirmationTextIsValid()"
        >
          Confirmar criação
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  name: "admin-profile",
  data() {
    return {
      model: {
        user: {
          email: "",
          password: "",
        },
        admin: {
          name: "",
          company_position: "",
        },
      },
      modals: {
        modalConfirmation: false,
        inputConfirmation: "",
      },
      error: "",
    };
  },
  methods: {
    handleOpenModalConfirmation() {
      this.modals.inputConfirmation = "";
      this.modals.modalConfirmation = true;
    },
    async handleSubmitNewAdmin(e) {
      e.preventDefault();
      this.error = "";
      this.model.user.email = this.model.user.email.trim();
      this.model.admin.name = this.model.admin.name.trim();
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation,
        width: 90,
        height: 90,
        opacity: 0,
      });
      try {
        await api.post("/admins", { ...this.model.user, ...this.model.admin });
        this.$toasted.show("Novo administrador cadastradro com sucesso");
        this.$router.push("/admin/acessos");
      } catch (e) {
        const genericError = "Ocorreu um erro ao cadastrar o administrador.";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.error = hasErrorResponseData ? customError : genericError;
        this.$toasted.error(genericError);
        this.modals.modalConfirmation = false;
      }
      loader.hide();
    },
    inputConfirmationTextIsValid() {
      return this.modals.inputConfirmation === this.model.user.email;
    },
  },
  computed: {
    isValidModel() {
      const user = this.model.user;
      const admin = this.model.admin;
      if (
        !user.email ||
        !user.password ||
        !admin.name ||
        !admin.company_position
      )
        return false;
      return true;
    },
    passwordStatus() {
      const status = {
        strong: {
          class: "text-success",
          message: "forte",
        },
        average: {
          class: "text-warning",
          message: "média",
        },
        weak: {
          class: "text-danger",
          message: "fraca",
        },
      };
      const length = this.model.user.password.length;
      return length < 6
        ? status.weak
        : length < 10
        ? status.average
        : status.strong;
    },
  },
};
</script>
<style scoped></style>
